/**
 * Status of the report being responded to.
 * - Tag: 3021
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const AlgoCertificateReportStatus = Object.freeze({
    /** Received, not yet processed */
    Received: 0,
    /** Accepted */
    Accepted: 1,
    Rejected: 2,
} as const);

export type AlgoCertificateReportStatus =
    (typeof AlgoCertificateReportStatus)[keyof typeof AlgoCertificateReportStatus];
